import { isApp } from '../core/is-app'
import { loggerFor } from '../singletons/logger'
import { featureTogglesAssetsAdapter } from '../adapters/otto-ec-globals/feature-toggle-adapter/feature-toggles-assets-adapter'

export type Bootstrap = () => void | Promise<void>
export type ToggleResolver = () => boolean | Promise<boolean>

const TOGGLE_KEY = 'cb_enable_consent_for_feature'
const TOGGLE_RESOLUTION_TIMEOUT_MS = 1000

const logger = loggerFor('consent-for-feature-guard')

const defaultToggleResolver: ToggleResolver = () =>
  featureTogglesAssetsAdapter(TOGGLE_KEY, false)

let toggleResolver: ToggleResolver = defaultToggleResolver

/**
 *
 *
 */
export function __setToggleResolverForTest(fn?: ToggleResolver): void {
  toggleResolver = fn ?? defaultToggleResolver
}

export async function runIfConsentForFeatureEnabled(
  bootstrap: Bootstrap
): Promise<void> {
  if (isApp()) return

  let enabled: boolean
  try {
    enabled = await resolveToggle()
  } catch (err) {
    logger.error(
      new Error(
        '[consent-for-feature-guard] Failed to resolve feature toggle — failing closed',
        { cause: err }
      )
    )
    return
  }

  if (!enabled) return

  try {
    await bootstrap()
  } catch (err) {
    logger.error(
      new Error('[consent-for-feature-guard] Bootstrap failed', { cause: err })
    )
  }
}

function resolveToggle(): Promise<boolean> {
  let timeoutId: ReturnType<typeof setTimeout>

  const togglePromise = Promise.resolve().then(() => toggleResolver())

  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(
        new Error(
          `Toggle resolution timed out after ${String(
            TOGGLE_RESOLUTION_TIMEOUT_MS
          )}ms`
        )
      )
    }, TOGGLE_RESOLUTION_TIMEOUT_MS)
  })

  return Promise.race([togglePromise, timeoutPromise]).finally(() => {
    clearTimeout(timeoutId)
  })
}
